export const arrangingTheSwap = [
  {
    header: "How do I obtain keys for the swapped house?",
    answer:
      "- In-Person: The host or a representative hands over the keys. \n \n \
      - Lockbox: You receive a code to access a lockbox with keys. \n \n \
      - Smart Lock/Keypad: Enter a code provided by the host. \n \n \
      - Nearby Pickup: Collect keys from a designated location.",
  },
  {
    header: "Can tenants exchange their apartments on HomeSwap?",
    answer:
      "It is up to each member to check their rights to swap homes prior to using our service.",
  },
  {
    header: "Who sets the conditions for the exchange?",
    answer:
      "The conditions for the exchange are set collaboratively by both members involved. This includes details like the dates of the exchange, house rules, and any specific agreements regarding the use of the property. Both parties are encouraged to communicate openly and agree on all conditions before finalizing the swap. This ensures that both members are comfortable and clear about the terms of the exchange.",
  },
  {
    header: "Is there a contract between exchanging parties?",
    answer:
      "Homeswap does not offer a standardized contract between members. However, exchanging partners can create an agreement, which functions as a contract. To outlines the agreed-upon terms such as dates, house rules, and responsibilities during the stay.",
  },
  {
    header: "How can I contact someone to arrange a swap?",
    answer:
      "To contact another member, you must first send a request, which the recipient needs to approve. Once approved, the contact details will become visible to you. ",
  },
];

export const aboutHomeSwap = [
  {
    header: "What is HomeSwap?",
    answer:
      "HomeSwap is a service that allows people to exchange their homes for vacations and/or student-abroad travels. Members can stay in each other's homes, providing an affordable and immersive travel experience.",
  },
  {
    header: "What are the advantages of using HomeSwap?",
    answer:
      "- Cost savings: Eliminate accommodation costs entirely. \n \n \
      - Comfort: Enjoy the comfort and amenities of a full home.  \n \n \
      - Flexibility: Wide variety of home types and locations worldwide.  \n \n \
      - Sustainable travel: Promotes eco-friendly travel by making use of existing resources.",
  },
  {
    header: "What does it mean to 'like' someone's post?",
    answer:
      "Liking a post automatically saves the listing to your 'liked posts' which you can go back and view afterwards. \n \n \
        It also helps you keep track of listings you like for future references.",
  },
  {
    header: "Is there a cost for a HomeSwap subscription?",
    answer: "No, signing-up and using our website is entirely free of charge!",
  },
];

export const successFullAd = [
  {
    header: "Write an attractive headline",
    answer:
      "Capture attention by highlighting the most appealing feature of the property, such as 'Recently Renovated Apartment in the Heart of Stockholm'.",
  },
  {
    header: "Provide a detailed description of the home ",
    answer:
      "Include information about the number of rooms, size, location, furnishings, and important amenities like Wi-Fi or parking. Be flexible to attract more interest.",
  },
  {
    header: "Use high-quality images",
    answer:
      "Professional photos increase the chances of sparking interest. Show the entire property, preferably with good lighting.",
  },
  {
    header: "Proximity to key locations",
    answer:
      "Inform about the distance to public transport, workplaces, restaurants, and other relevant places for potential renters.",
  },
  {
    header: "Be clear about your preferences",
    answer:
      "Specify the desired exchange time, what type of accommodation you are looking for, and any rules to avoid misunderstandings later.",
  },
];

export const successFullSwap = [
  {
    header: "Describe your home honestly",
    answer:
      "When you provide a description of your home, be transparent and truthful. Offer a clear picture of your residence so that potential exchange partners know what to expect. Honesty is crucial for creating a reliable and rewarding exchange experience for everyone involved.",
  },
  {
    header: "Good communication for a successful exchange",
    answer:
      "A successful home exchange is built on open and effective communication. By maintaining a clear and continuous dialogue with your exchange partners, you can create a smooth and satisfying experience together.",
  },
  {
    header: "Show respect for each other's homes",
    answer:
      "In a successful home exchange, mutual respect for each other’s residences is of great importance. By showing care and consideration for your exchange partner’s home, you build a foundation of trust and friendship that leads to a memorable experience.",
  },
];

export const technicalSupport = [
  {
    header: "Why am I unable to contact another member?",
    answer:
      "If you’re unable to contact another member, don’t worry its most likely a technical issue. To successfully contact another member, you must first send a request, which the recipient needs to approve. Once approved, the contact details will become visible to you. ",
  },
  {
    header: "How do I report bugs on the website?",
    answer:
      "If you have any questions or need assistance, please reach out to us at contact@internationalhomeswap.com. Our team is here to help with any inquiries or issues you may have.",
  },
  {
    header: "How do I report spam?",
    answer:
      "If you have any questions or need assistance, please reach out to us at contact@internationalhomeswap.com. Our team is here to help with any inquiries or issues you may have.",
  },
];

export const accountDetails = [
  {
    header: "How do I upload my home?",
    answer:
      "When creating your account, you will be guided through the steps to upload your home. You can only upload your home once you become a member by selecting the icon in the top right corner.",
  },
  {
    header: "How do I edit my account?",
    answer:
      "You can edit your account by clicking on the setting icon in the top right corner and thereafter click on edit profile.",
  },
  {
    header: "Who can see my posts?",
    answer:
      "Individuals without an HomeSwap account have limited access to view profiles. Your contact details are only shared when both parties express interest in a swap",
  },
];

export const guideLines = [
  {
    header: "Does HomeSwap check the status of my home after the swap?",
    answer: "No, HomeSwap does not conduct home inventories.",
  },
  {
    header: "Are there any rules for HomeSwap?",
    answer:
      "We encourage members to follow the five principles for a successful home exchange.",
  },
  {
    header:
      "What if someone asks me to make payments outside of HomeSwap’s platform?",
    answer:
      "If someone asks you to make payments outside of the HomeSwap platform, it's a red flag and should be avoided. HomeSwap, like similar platforms, strongly advises against making any payments outside its secure system. \n \n \
      Conducting transactions off-platform can expose you to fraud, and you'll lose the protections offered by HomeSwap, such as insurance coverage and support in case of disputes.",
  },
];

export const community = [
  {
    header: "What is the HomeSwap community?",
    answer:
      "The HomeSwap community is a global network of members who participate in home exchanges for vacation, travel purposes or study-abroad semesters. It's a supportive community of like-minded individuals who want to share their homes and build connections across the globe. ",
  },
];
